import { InjectionToken } from '@angular/core';
import { NPwa } from './pwa.interface';

export const PWA_OPTIONS = new InjectionToken<NPwa.IModuleOptions>('PWA_OPTIONS');
